import { atom } from 'jotai';

export enum NotificationType {
  success,
  failed,
}

const notificationAtom = atom<{
  show: boolean;
  type: NotificationType | null;
  title: string | null;
}>({
  show: false,
  type: null,
  title: null,
});

const pageLoadingAtom = atom<boolean>(false);

export { notificationAtom, pageLoadingAtom };
